/**
 *
 * key
 *
 */

 const key = 'b3BlcmF0aW9uRm9sbG93dXBDb21wbGV0ZWRMaXN0'

 export default key
 